import React from "react";
import Alert from "components/Alert";
import TileSubPanel from "components/TileSubPanel";
import ZendeskLink from "components/Help/ZendeskLink";
import OverviewListItem from "./OverviewListItem";
import BlocksOverview from "./BlocksOverview";
import { getBlockList } from "common/utils";
import * as domain from "common/domain";
import FeatureTracker, { FEATURES } from "components/FeatureTracker/FeatureTracker";

const Overview = (props) => {
    const { farm, budget, refData, expandAll } = props;

    const blockList = getBlockList(budget.blocks);
    const fodderCropBlocks = blockList.productiveBlocks.filter((block) => block.type === domain.BlockType.FodderCrop);
    const pastureBlocks = blockList.productiveBlocks.filter((block) => block.type === domain.BlockType.ProductivePasture);
    const fruitBlocks = blockList.productiveBlocks.filter((block) => block.type === domain.BlockType.ProductiveFruit);
    const cropBlocks = blockList.productiveBlocks.filter((block) => block.type === domain.BlockType.ProductiveCrop);
    const outdoorPigBlocks = blockList.productiveBlocks.filter((block) => block.type === domain.BlockType.ProductiveOutdoorPigs);
    const otherBlocks = blockList.nonProductiveBlocks;
    const hasResults = budget && budget.currentResults && budget.currentResults.nitrogenOverview;

    return (
        <>
            <FeatureTracker feature={FEATURES.BLOCK_SUMMARY} farm={farm} />
            <Alert className="u-print-none" type="info" text="You can print this page by selecting print under the browser menu. For PDF, change the destination to PDF. Portrait is recommended for this report." moreInfo={<ZendeskLink title="Page help" url="https://support.overseer.org.nz/hc/en-us/articles/900000978743" className="IconLink--new-tab u-font-green" />} />
            {hasResults && <BlocksOverview budget={budget} />}
            {pastureBlocks.length > 0 && (
                <TileSubPanel title="Pasture blocks" stickyHeaderName="budget.overview.overview.pastureBlocks.collapsed">
                    {pastureBlocks.map((block) => (
                        <OverviewListItem key={block.id} block={block} refData={refData} farm={farm} budget={budget} expandAll={expandAll} />
                    ))}
                </TileSubPanel>
            )}
            {cropBlocks.length > 0 && (
                <TileSubPanel title="Crop blocks" stickyHeaderName="budget.overview.overview.cropBlocks.collapsed">
                    {cropBlocks.map((block) => (
                        <OverviewListItem key={block.id} block={block} refData={refData} farm={farm} expandAll={expandAll} budget={budget} />
                    ))}
                </TileSubPanel>
            )}
            {fodderCropBlocks.length > 0 && (
                <TileSubPanel title="Fodder crop rotations" stickyHeaderName="budget.overview.overview.fodderCropRotations.collapsed">
                    {fodderCropBlocks.map((block) => (
                        <OverviewListItem key={block.id} block={block} refData={refData} farm={farm} expandAll={expandAll} budget={budget} />
                    ))}
                </TileSubPanel>
            )}
            {fruitBlocks.length > 0 && (
                <TileSubPanel title="Fruit blocks" stickyHeaderName="budget.overview.overview.fruitBlocks.collapsed">
                    {fruitBlocks.map((block) => (
                        <OverviewListItem key={block.id} block={block} refData={refData} farm={farm} expandAll={expandAll} budget={budget} />
                    ))}
                </TileSubPanel>
            )}
            {outdoorPigBlocks.length > 0 && (
                <TileSubPanel title="Outdoor pigs" stickyHeaderName="budget.overview.overview.outdoorPigs.collapsed">
                    {outdoorPigBlocks.map((block) => (
                        <OverviewListItem key={block.id} block={block} refData={refData} farm={farm} expandAll={expandAll} budget={budget} />
                    ))}
                </TileSubPanel>
            )}
            {otherBlocks.length > 0 && (
                <TileSubPanel title="Other blocks" stickyHeaderName="budget.overview.overview.otherBlocks.collapsed">
                    {otherBlocks.map((block) => (
                        <OverviewListItem key={block.id} block={block} refData={refData} farm={farm} expandAll={expandAll} budget={budget} />
                    ))}
                </TileSubPanel>
            )}
        </>
    );
};

export default Overview;
